export enum BOOKING_SPACE_STATUS {
  AVAILABLE = 'available',
  OCCUPIED = 'occupied',
  OUT_OF_SERVICE = 'out_of_service',
  MAINTENANCE = 'maintenance',
  RESERVED = 'reserved'
}
